<template>
  <div>
    <ali-player v-if="playAuth"
      :encryptType="1"
      :vid="vid"
      :playauth="playAuth"
      ref="player"
      :useFlashPrism="false"
      :autoplay="true"
      :isLive="false"
      :showBuffer="true"
      :cover="cover"
      :showBarTime="true"
      :disableSeek="true"
      width="90%"
      videoHeight="100%"
      controlBarVisibility="always"
    >
    </ali-player>
  </div>
</template>

<script>
import Aliplayer from "@/components/aliyun/AliPlayer.vue";
import $ from "jquery";
import { ElMessage } from "element-plus";

export default {
  components: { "ali-player": Aliplayer },

  data() {
    return {
      cover: "", //视频封面
      vid: "", //视频vid
      playAuth: "", //鉴权地址
    };
  },
  mounted() {
    this.getVideoData();
    this.calcTime();
  },
  methods: {
    getVideoData() {
      const videoId = this.$route.params.videoId;
      this.vid = videoId;
      
      const token = localStorage.getItem("token");
      
      // 获取播放凭证，通过视频ID
      $.ajax({
        url: "http://124.222.105.205:5000/api/video/getPlayAuth",
        data: { 
            vid: videoId
         },
        type: "post",
        headers: {
          Authorization: "Bearer " + token,
        },
        success: (resp) => {
          if (resp.code == "200") {
            this.playAuth = resp.data;
          } else {
            ElMessage({
              type: "error",
              message: resp.msg,
            });
          }
        },
        error: () => {
          ElMessage({
            type: "error",
            message: "拉取视频失败!",
          });
        },
      });
    },

    calcTime() {
      let allTime;
      var loadVideo = setInterval(() => {
        allTime = this.$refs.player.getDuration();
        if (!isNaN(allTime)) {
          console.log("视频已准备好，总时长为：" + allTime);

          let fraction = allTime / 3; // 计算每份的大小

          // console.log(fraction);

          setTimeout(() => {
              // console.log("同步第1次" + this.$refs.player.getCurrentTime());
              // console.log("同步第1次" + fraction.toFixed(1));
              this.syncVideoRecord(this.vid, "33");
            }, Math.round(fraction * 1000));

            setTimeout(() => {
              // console.log("同步第2次" + this.$refs.player.getCurrentTime());
              // console.log("同步第2次" + (fraction * 2).toFixed(1));
              this.syncVideoRecord(this.vid, "67");
            }, Math.round(fraction * 2 * 1000));

            setTimeout(() => {
              // console.log("同步第3次" + this.$refs.player.getCurrentTime());
              // console.log("同步第3次" + (fraction * 3).toFixed(1));
              this.syncVideoRecord(this.vid, "100");
            }, Math.round(fraction * 3 * 1000));

          clearInterval(loadVideo); // 清除定时器
        } else {
          console.log("视频总时长无效");
        }
      }, 1000);
    },

    syncVideoRecord(vid, process) {
        const token = localStorage.getItem("token");
        const self = this; // 保存组件实例的引用
        $.ajax({
          url: "http://124.222.105.205:5000/api/data/addVideoStudyRecord",
          data: {
            vid: vid,
            progress: process
          },
          type: "post",
          headers: {
            Authorization: "Bearer " + token,
          },
          success(resp) {
            if (resp.code == "200") {
              // 刷新
              self.$emit('uploadChapter');
            }
          },
          error() {
            ElMessage({
              type: "error",
              message: "学习记录添加失败",
            });
          },
        });
      },
  },
};
</script>

<style scoped>
</style>